// extracted by mini-css-extract-plugin
export default {"switch":"style_switch__Y8AXG","checked":"style_checked__Ec8XD","disabled":"style_disabled__N8vVm","input":"style_input__MDTDv"};